<template>
  <div class="d-flex report-box-parent mt-3 mb-lg-3 mb-0">
    <div v-if="data.length === 0 && !loading" class="empty-data">
      No data available
    </div>
    <div
      class="flex-1"
      v-for="(item, index) in data"
      :key="index"
      :class="loading ? 'dashboard-load-div' : ''"
    >
      <div class="report-box">
        <div class="report-box-title">
          {{ item.label }}
        </div>
        <div class="report-box-value">
          <ProgressSpinner v-if="loading" />
          <span v-else>
            {{
              typeof item.value === 'string'
                ? item.value
                : $commonFuction
                    .numberFormat(item.value || 0, decimal)
                    .replace(/\,0+$/, '')
            }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    decimal: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss">
.report-box {
  background: #f7f2f4;
  border: 1px solid #f7f2f4;
  height: 80px;
  width: 100%;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .report-box-title {
    font-size: 16px;
    color: #333333;
    height: 30px;
    text-align: center;
    line-height: 17px;
  }

  .report-box-value {
    color: #a1000f;
    font-size: 24px;
    font-weight: bold;
  }
}

.manager-title {
  font-size: 24px;
}

.dashboard-load-div {
  opacity: 0.5;
  .p-progress-spinner {
    width: 30px;
    height: 30px;
  }
}

@keyframes p-progress-spinner-color {
  100%,
  0% {
    stroke: #a1000f;
  }
  40% {
    stroke: #a1000f;
  }
  66% {
    stroke: #a1000f;
  }
  80%,
  90% {
    stroke: #a1000f;
  }
}

.report-box-parent {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.flex-1 {
  min-width: 205px;
  width: auto;
  padding: 10px 10px 30px;
}

@media (max-width: 960px) {
  .report-box-parent {
    margin-left: 10px !important;
  }
  .report-box-parent .flex-1 {
    flex: 0 0 50%;
    width: 155px !important;
    max-width: 50% !important;
    padding: 10px;
  }
}

@media (max-width: 600px) {
  .report-box-parent .flex-1 {
    flex: 0 0 100%;
    width: 100% !important;
  }
}

.empty-data {
  font-size: 16px;
  color: #666;
  text-align: center;
  margin: 20px 0;
}
</style>
